/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Fal_Api_KeyInputs */

const en_admin_settings_fields_fal_api_key = /** @type {(inputs: Admin_Settings_Fields_Fal_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const zh_admin_settings_fields_fal_api_key = /** @type {(inputs: Admin_Settings_Fields_Fal_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥`)
};

/**
* | output |
* | --- |
* | "API Key" |
*
* @param {Admin_Settings_Fields_Fal_Api_KeyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_fal_api_key = /** @type {((inputs?: Admin_Settings_Fields_Fal_Api_KeyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Fal_Api_KeyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_fal_api_key(inputs)
	return zh_admin_settings_fields_fal_api_key(inputs)
});
export { admin_settings_fields_fal_api_key as "admin.settings.fields.fal_api_key" }